import { Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Routes } from "react-router-dom";
import LandingPage from "./pages/LandingPage/LandingPage";
import Transaction from "./pages/Transaction/Transaction";

const App=()=>{
    const navigate=useNavigate();
    return <>
    <h1 onClick={()=>navigate("/")}>
        XTracker
    </h1>
<Routes>
    <Route path="tracker" element={<Transaction/>} />
    <Route path="/" element={<LandingPage/>}/>
</Routes>
   
    </>
}
export default App;